import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ScrollLink from 'components/fulcrum/scrollLink/index'
import ListItem from './ListItem'

const Link = (props) => {
  const {
    containerId,
    to,
    label
  } = props

  return (
    <ListItem>
      <ScrollLink
        label={label}
        to={to}
        containerId={containerId}
      />
    </ListItem>
  )
}

export default Link
